import { render, staticRenderFns } from "./OriginatorIcon.vue?vue&type=template&id=e2b9e246"
import script from "./OriginatorIcon.vue?vue&type=script&lang=js"
export * from "./OriginatorIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports